<template>
	<transition name="play">
		<div v-if="path === '/playlist'">
			<div class="add">
				<span @click="addNewPlaylist"
				      v-if="getReqUserRole === 'Администратор уровня Бог'"
				>add new playlist++</span>
				<!--v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'"-->
				<span @click="genre">genre</span>
			</div>
			<div class="left">
				<div class="row"
				     v-for="(item, i) in getPlaylists"
				     :value="i"
				     @click.stop="editPlaylistLeft"
				     :key="i">
					<div class="edit"
					     v-if="getReqUserRole === 'Администратор уровня Бог'"
					     @click.stop.self="editNamePlaylist"
					     title="сменить имя">
					</div>
					<p class="cell"
					   v-for="(j, k) in item"
					   :key="k"><span class="elem">{{j}}</span>
					</p>
				</div>
			</div>
		</div>
		<div class="left2"
		     v-else-if="path === '/channel_edit'">
			<input type="text" id="find" placeholder="Поиск" @keyup="sort">
			<transition name="play">
				<div class="editing" v-if="!editing">
					<div class="popup">
						<div class="title">
							Изменения не сохранены!
							<br>
							Вы можете сохранить/отменить либо продолжить редактирование
						</div>
						<div class="buttons">
							<button @click="editChannel('save')">save</button>
							<button @click="editChannel('cancel')">cancel changes</button>
							<button @click="cencelPopap">cancel</button>
						</div>
					</div>
				</div>
			</transition>
			<p id="cell"
			   v-for="(item, i) in getChannelList"
			   :value="i"
			   :key="i"
			   @click="editPlaylistLeft2">{{ item.display_name || ""}}
				<span class="small">{{item.is_ottfree ? "OTT free" :
				""}}
				</span>
			</p>
		</div>
	</transition>
</template>
<script>
	import { performRequest }                                 from "../script/ws/wsclient";
	import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
	import { eventEmmiter }                                   from "../main";

	export default {
		name:     "PlaylistLeft",
		data() {
			return {
				path:     "",
				editing:  true,
				select:   null
			};
		},
		created() {
			eventEmmiter.$on("hiddenPopupCh", v => {
				this.editing = v;
			});
		},
		beforeDestroy() {
			eventEmmiter.$off("hiddenPopupCh")
		},
		mounted() {
			this.path = this.$route.path;
			performRequest(
				{
					section: "tvcontent.playlist",
					name:    "getPlaylistList"
				},

				{
					operator: this.getViewUser
				},
				a => {
					if (a.code === 200) {
						this.setPlaylists(a.data);
					} else {
						console.log("ошибка при получении плейлистов");
					}

				}
			);
			performRequest(
				{
					section: "tvcontent.genre",
					name:    "getGenreList"
				},
				{
					operator: this.getViewUser
				},
				a => {
					if (a.code === 200) {
						this.setGenre(a.data);
					} else {
						console.log("ошибка при получении жанров");
					}

				}
			);
			performRequest(
				{
					section: "tvcontent.channel",
					name:    "getChannelList"
				},
				{
					operator: this.getViewUser
				},
				a => {
					if (a.code === 200) {
						// let data;
						if (this.getReqUserRole !== "Администратор уровня Бог") {
							// data = a.data.map(item => {
							// 	delete item.operator;
							// 	return item;
							// });
							this.setChannelist(a.data);
							let ott = this.getChannelList;
							this.setOtt(ott[0].is_ottfree);
						} else {
							this.setChannelist(a.data);
						}
					} else {
						console.log("ошибка при получении доступных каналов");
					}

				}
			);
		},
		updated() {
			this.editSelector();
			if (this.$route.path === "/playlist") {
				this.setCountChannel(0);
			}
		},
		computed: {
			...mapGetters([
				"getPlaylists",
				"getCountPlaylists",
				"getChannelList",
				"getCountChannel",
				"getPlaylist",
				"getEditingPlaylist",
				"getUserRights",
				"getReqUserRole",
				"getEditingChannelList",
				"getOtt",
				"getCurrentOperator",
				"getViewUser",
				"getChannels"
			]),
			...mapState(["thisChannel"])
		},
		methods:  {
			...mapActions([
				"setPlaylists",
				"setChannelist",
				"setPlaylist"
			]),
			...mapMutations([
				"setCountPlaylists",
				"setCountChannel",
				"setGenre",
				"setEditingPlaylist",
				"setCh",
				"setOtt"
			]),
			hiddenSort(item) {
				item.style.visibility   = "visible";
				item.style.height       = "";
				item.style.padding      = "0.4rem 0.5rem";
				item.style.margin       = "0 1rem";
				item.style.border       = "2px solid transparent";
				item.style.borderBottom = "2px solid rgba(86, 221, 96, 0.89)";
			},
			sort(e) {
				let channels = document.querySelectorAll("p#cell");
				if (e.target.value === "") {
					channels.forEach(item => {
						this.hiddenSort(item);
					});
				} else {
					this.getChannelList.forEach((item, index) => {
						if (item.display_name.toUpperCase().indexOf(e.target.value.toUpperCase()) !== -1) {
							// channels[index].classList.add("find_channel");
							this.hiddenSort(channels[index]);
						} else {
							// channels[index].classList.remove("find_channel");
							channels[index].style.visibility = "hidden";
							channels[index].style.height     = "0";
							channels[index].style.padding    = "0";
							channels[index].style.margin     = "0";
							channels[index].style.border     = "none";

						}
					});
				}
			},
			errorSave() {
				this.editing = false;
			},
			cencelPopap() {
				this.editing = true;
			},
			editChannel(val) {
				eventEmmiter.$emit("errorSave", val);
			},
			editPlaylistLeft(e) {
				this.setCountPlaylists(e.currentTarget.getAttribute("value"));

				performRequest(
					{
						section: "tvcontent.playlist",
						name:    "getPlaylistChannelList"
					},
					{
						name:     this.getPlaylists[
							          e.currentTarget.getAttribute("value")
							          ].name,
						operator: this.getViewUser
					},
					a => {
						this.setPlaylist(a.data);
						this.$router.push("/playlist_edit");
					}
				);
			},
			editPlaylistLeft2(e) {
				if (this.getEditingChannelList === true) {
					this.setCountChannel(+e.currentTarget.getAttribute("value"));
					this.setCh(this.getChannelList[this.getCountChannel].name);
					this.editSelector();
					this.setOtt(this.getChannelList[this.getCountChannel].is_ottfree);

					Object.assign(this.thisChannel,
						this.getChannelList[this.getCountChannel]);
					delete this.thisChannel.genreList;
					// delete this.thisChannel.operator;
					this.$router.push("/channel_edit");
					this.thisChannel.genreList =
						[].slice.call(this.getChannelList[this.getCountChannel].genreList);
				} else {
					this.errorSave();
				}

			},
			editSelector() {
				document.documentElement.scrollTop = 0;
				let row                            = Array.from(document.querySelectorAll(".left2 #cell"));
				for (let i in row) {
					if (row.hasOwnProperty(i)) {
						row[i].classList.remove("select");
						row[this.getCountChannel].classList.add("select");
					}
				}
			},
			addNewPlaylist() {
				this.setEditingPlaylist(false);
				this.$router.push("/add_new_playlist");
			},
			genre() {
				this.$router.push("/genre");
			},
			editNamePlaylist(e) {
				this.setEditingPlaylist(true);
				this.setCountPlaylists(e.target.parentNode.getAttribute("value"));
				this.$router.push("/add_new_playlist");
			}
		}
	};
</script>
<style scoped lang="scss">
	.left {
		background-color: rgba(238, 238, 200, 0.8);
		box-shadow: inset 0 0 5px rgba(51, 51, 51, 0.4), 1px 1px 5px #333;
		padding: 0.5rem 0.5rem 1rem 0.5rem;
		height: calc(100vh - 7rem);
		overflow: auto;
		position: absolute;
		margin-top: 6rem;
		width: 90%;
		right: 50%;
		min-width: 30rem;
		transform: translateX(50%);
		display: flex;
		flex-direction: column;
		
		.row {
			display: block;
			border-bottom: 1px solid rgba(86, 221, 96, 0.89);
			margin: 0 1rem;
			padding: 0.4rem 0.5rem;
			cursor: pointer;
			transition: background-color 0.3s;
			min-width: 35rem;
			position: relative;
			.cell {
				width: calc((100% / 4));
				display: inline-block;
				text-align: center;
				margin: 0 1rem 0 1rem;
				vertical-align: top;
				padding: .2rem;
				height: 3rem;
				transition: all .3s;
				.elem {
					display: inline-block;
					margin-right: 1rem;
					
				}
			}
			.edit {
				position: absolute;
				top: 0;
				left: 0;
				width: 0;
				height: 100%;
				background: #fff url("../../static/edit.png") no-repeat center;
				background-size: 65%;
				transition: width .3s;
				.name_playlist {
					position: absolute;
					left: -15px;
					top: -5px;
					display: none;
				}
				.visible {
					display: block;
				}
			}
			&:hover {
				background-color: #c7bae0;
				border-bottom: 1px solid #ff4648;
			}
			&:hover .edit {
				width: 2rem
			}
		}
		
		.header {
			background-color: rgba(173, 198, 255, 0.74);
			font-weight: bold;
			padding: 0.5rem;
			border: none;
			cursor: default;
			
			&:hover {
				background-color: rgba(173, 198, 255, 0.74);
				border: none;
			}
		}
		
	}
	.small {
		font-size: .6rem;
		color: #6e0b08;
	}
	.add {
		position: absolute;
		top: 4rem;
		width: 90%;
		right: 50%;
		transform: translateX(50%);
		font-size: 0;
		
		span {
			font-size: 1rem;
			cursor: pointer;
			padding: 0.5rem;
			transition: all 0.3s;
			border-right: 1px solid #ccc;
			
			&:first-child {
				border-left: 1px solid #ccc;
			}
			
			&:hover {
				background-color: #c1ffb3;
			}
			
			&:active {
				box-shadow: 0 0 6px #111111;
			}
		}
	}
	.left2 {
		background-color: rgb(238, 238, 200);
		box-shadow: inset 0 0 5px rgba(51, 51, 51, 0.4), 1px 1px 5px #333;
		padding: 2rem 0.5rem;
		display: block;
		height: calc(100vh - 5rem);
		overflow-y: scroll;
		max-width: 200px;
		min-width: 200px;
		#find {
			position: fixed;
			top: 0;
			left: 0;
			width: 184px;
			outline: none;
			border-radius: 3px 0 0 0;
			border: none;
			box-shadow: inset 0 0 3px #606a64;
			padding: 2px 5px;
		}
		.editing {
			height: 100%;
			width: 100%;
			position: absolute;
			background-color: rgba(180, 152, 102, 0.16);
			top: 0;
			left: 50%;
			transform: translateX(-50%);
			z-index: 10000;
			.popup {
				width: 400px;
				height: 200px;
				background-color: rgba(128, 183, 236, 0.96);
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				box-shadow: inset 0 0 10px #5b5b5b;
				border-radius: 5px;
				.title {
					font-size: 1.2rem;
					margin: 10px;
					padding: 15px 0 10px 0;
					color: #ffffff;
					text-align: center;
				}
				
				.buttons {
					display: flex;
					flex-direction: row;
					justify-content: space-around;
					padding: 20px;
					button {
						background: #bbf291;
						border-radius: 0.2rem;
						line-height: 1.8rem;
						border: none;
						outline: none;
						height: 2.5rem;
						padding: 0.2rem 1rem;
						transition: all 0.2s;
						cursor: pointer;
						margin: 0.5rem;
						&:disabled {
							background-color: rgba(157, 174, 146, 0.54);
							&:hover {
								background-color: rgba(157, 174, 146, 0.54);
								cursor: default;
								&:active {
									box-shadow: 0 0 1rem #967068;
								}
							}
						}
						&:hover {
							background: #78956b;
							color: white;
							
							&:active {
								box-shadow: 0 0 1rem #967068;
							}
						}
					}
				}
			}
		}
		#cell.select {
			background-color: #a8ffbb;
			
			&:hover {
				background-color: #86cc99;
			}
		}
		
		#cell {
			display: block;
			font-weight: bold;
			font-size: .9rem;
			letter-spacing: 0.05rem;
			border: 2px solid transparent;
			border-bottom: 2px solid rgba(86, 221, 96, 0.89);
			margin: 0 1rem;
			padding: 0.4rem 0.5rem;
			cursor: pointer;
			transition: all 0.3s;
			/*max-height: 45px;*/
			&:last-child {
				border-bottom: 2px solid transparent;
			}
			
			&:hover {
				background-color: #c7bae0;
				border-bottom: 2px solid #ff4648;
			}
			
			&:active {
				box-shadow: 0 0 6px #111111;
			}
		}
		#cell.find_channel {
			background-color: #d188ff;
		}
		#cell.find_channel.select {
			background-color: #a8ffbb;
			border: 2px solid #d188ff;
		}
	}
	@media (max-width: 750px) {
		.left2 {
			display: none;
			height: calc(100vh - 6rem);
		}
	}
	@media (max-width: 620px) {
		.left {
			margin-top: 10rem;
			height: calc(100vh - 11rem);
		}
		.add {
			top: 8rem;
		}
	}
	.play-enter-active {
		transition: all 0.5s ease;
	}
	.play-leave-active {
		transition: all 0.5s ease;
	}
	.play-enter, .play-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/PlaylistLeft.vue